import { EPrivateRoutes } from "@core-types/routes.enum";
import { useAppNavigate } from "@hooks/language/useAppNavigate";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { Group, Text } from "@mantine/core";
import useUserStore from "@store/user.store";
import Coins from "./Coins";
import UseMyCoinsButton from "./UseMyCoinsButton";
import ContainerCard, {
  type IContainerCardProps,
} from "./container/ContainerCard";

interface ICoinCardProps {
  displayButton?: boolean;
  containerProps?: IContainerCardProps;
  className?: string;
}

const CoinCard: React.FC<ICoinCardProps> = ({
  displayButton = true,
  containerProps,
  className,
}) => {
  const { t } = useAppTranslation("components.clientDashboard.coinCard");
  const { navigate } = useAppNavigate();

  const { affiliationInformation } = useUserStore();

  return (
    <ContainerCard
      title={t("title")}
      {...containerProps}
      classNames={{
        ...containerProps?.classNames,
        wrapper: `flex h-full w-fit items-center gap-5 ${containerProps?.classNames?.wrapper}`,
      }}
    >
      <Group align="center" gap={64} className={className}>
        <Text className="flex items-center justify-center gap-1 font-inter text-primary-white">
          <Coins size={44} />
          <span className="font-semibold text-4xl">
            {affiliationInformation?.coinBalance}
          </span>
        </Text>
        {displayButton && (
          <UseMyCoinsButton onClick={() => navigate(EPrivateRoutes.REWARDS)} />
        )}
      </Group>
    </ContainerCard>
  );
};

export default CoinCard;
